import React from "react";
import {
  FunctionField,
  ReferenceField,
  required,
  ReferenceInput,
  SelectInput,
  Create,
  SimpleForm,
  TextInput
} from "react-admin";

const SportCodeInput = () => (
  <ReferenceInput label="Sport" source="sportCode" reference="sportCodes">
    <SelectInput
      optionText="label"
      optionValue="code"
      validate={[required()]}
    />
  </ReferenceInput>
);

const TeamCreate = (props) => {
  const redirect = function(basePath, id, data) {
    console.log("TeamCreate.redirect()", basePath, id, data);
    return `/schools/${data.school.id}/show/1`;
  };

  return (
    <Create {...props}>
      <SimpleForm redirect={redirect}>
        <ReferenceField label="School" source="school_id" reference="schools">
          {/*<TextField source="name" />*/}
          <FunctionField
            label="School"
            render={(record) => `${record.name} (${record.id})`}
          />
        </ReferenceField>
        <SportCodeInput />
        <TextInput source="name" validate={[required()]} />
        <TextInput source="teamCode" />
      </SimpleForm>
    </Create>
  );
};

export default TeamCreate;
